import type * as React from "react";

import { cn } from "@/lib/utils";

// The frontend's own Skeleton, themed with the dashboard tokens. It does not
// re-export the shared-ui package's Skeleton, whose bg-primary/10 default
// belongs to the admin app's theme; scripts/no-legacy-skeleton.sh flags that
// import under apps/frontend/src. `className` is merged last, so a caller's
// background class replaces the default.
function Skeleton({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
	return (
		<div
			className={cn("animate-pulse rounded-md bg-dashboard-surface", className)}
			{...props}
		/>
	);
}

interface SkeletonRowsProps {
	/** Read by screen readers in place of the visible rows. */
	label: string;
	rows?: number;
	className?: string;
	rowClassName?: string;
}

function SkeletonRows({
	label,
	rows = 3,
	className,
	rowClassName,
}: SkeletonRowsProps): React.ReactElement {
	return (
		<div role="status" className={cn("space-y-3", className)}>
			<span className="sr-only">{label}</span>
			{Array.from({ length: rows }, (_, i) => (
				<Skeleton
					key={`skeleton-row-${String(i)}`}
					className={cn("h-12 w-full", rowClassName)}
				/>
			))}
		</div>
	);
}

export { Skeleton, SkeletonRows };
